<template>
  <div>
    <div v-show="active === 'shippers'">
      <BitrixShippersForm />
    </div>
    <div v-show="active === 'transporters'">
      <BitrixTransportersForm />
    </div>
  </div>
</template>

<script>
import BitrixShippersForm from '@/components/bitrix/BitrixShippersForm'
import BitrixTransportersForm from '@/components/bitrix/BitrixTransportersForm'
export default {
  name: 'transporters',
  components: {
    BitrixShippersForm,
    BitrixTransportersForm,
  },
  computed: {
    active() {
      return this.$store.state.forms.activeForm
    },
  },
}
</script>
